<template>
  <v-dialog v-model="dialog" width="700px">
    <v-card v-if="ready === true" class="pa-3">

      <v-row  no-gutters class="ma-1">
        <div style="display: flex; flex-direction: row; gap: 15px;">
          <div>Arrival / Departure adjustment</div>
          <div v-if="huov.pp_connectionname!==''" style="display: flex; flex-direction: row; gap: 5px; color: red; font-weight: 700;">
            <div>{{ huov.pp_parkname }}</div>
            <div>-</div>
            <div>{{ huov.pp_connectionname }}</div>
            <div>-</div>
            <div>{{ huov.pp_connectiontype }}</div>
          </div>
        </div>
      </v-row>

      <v-row  no-gutters class="ma-1">
        <div v-if="!huov.pp_updatedates" style="font-weight: 500; margin-top: auto; padding-bottom: 3px">(dates cannot be updated)</div>
      </v-row>

      <v-divider style="color:lightslategrey" class="mt-4 mb-4"></v-divider>

      <v-form ref="huovArrDep" v-model="huovArrDepValid">
        <v-row no-gutters>
          <v-col cols="3" class="px-1">
            <v-menu
              v-model="huovVanDatmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="!huov.pp_updatedates || !huov.allowChangeDate"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="huov.huov_van_dat"
                  label="Arrival date"
                  v-on="on"
                  :readonly="!huov.pp_updatedates || !huov.allowChangeDate"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="huov.huov_van_dat2"
                :first-day-of-week="1"
                @input="huov.huov_van_dat = $moment(huov.huov_van_dat2).format('DD-MM-YYYY'); huovVanDatmenu = false"
                >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-select v-model="huov.huov_van_tijd1" :items="huov_van_tijd1Keuzes" menu-props="auto" item-value="huov_van_tijd1" item-text="huov_van_tijd1Tijd" label="Arrival from" :readonly="!huov.pp_updatedates"></v-select>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-select v-model="huov.huov_van_tijd2" :items="huov_van_tijd2Keuzes" menu-props="auto" item-value="huov_van_tijd2" item-text="huov_van_tijd2Tijd" label="Arrival until" :readonly="!huov.pp_updatedates"></v-select>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="3" class="px-1">

            <v-menu
              v-model="huovTmDatmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="!huov.pp_updatedates || !huov.allowChangeDate"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="huov.huov_tm_dat"
                  label="Departure date"
                  v-on="on"
                  :readonly="!huov.pp_updatedates || !huov.allowChangeDate"
                ></v-text-field>
              </template>
              <v-date-picker v-model="huov.huov_tm_dat2" :first-day-of-week="1" @input="huov.huov_tm_dat = $moment(huov.huov_tm_dat2).format('DD-MM-YYYY'); huovTmDatmenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-select v-model="huov.huov_tm_tijd1" :items="huov_tm_tijd1Keuzes" menu-props="auto" item-value="huov_tm_tijd1" item-text="huov_tm_tijd1Tijd" label="Departure from" :readonly="!huov.pp_updatedates"></v-select>
          </v-col>
          <v-col cols="2" class="px-1">
            <v-select v-model="huov.huov_tm_tijd2" :items="huov_tm_tijd2Keuzes" menu-props="auto" item-value="huov_tm_tijd2" item-text="huov_tm_tijd2Tijd" label="Departure until" :readonly="!huov.pp_updatedates"></v-select>
          </v-col>
        </v-row>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary mx-2"
          small
          @click="handleSave"
          :disabled="!huovArrDepValid||!huov.pp_updatedates"
          >Save</v-btn
        >
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>

      <!-- Embedded confirmation dialog -->
      <v-dialog v-model="confirmDialog" max-width="550px" persistent>
        <v-card>

          <v-card-title :class="isOverridable ? 'warning darken-1 white--text' : 'red darken-1 white--text'" class="py-3">
            <v-icon left color="white" size="28">{{ isOverridable ? 'mdi-alert' : 'mdi-alert-circle' }}</v-icon>
            <span class="headline font-weight-medium">{{ isOverridable ? 'Warning' : 'Error' }}</span>
          </v-card-title>

          <v-card-text class="pt-5 pb-3 px-5" style="font-size: 15px;">
            {{ confirmMessage }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="cancelProcess">{{ isOverridable ? 'Cancel' : 'Close' }}</v-btn>
            <v-btn v-if="isOverridable" small color="primary" @click="proceedWithUpdate">Proceed Anyway</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      huov_encrid: null,
      huovArrDepValid: false,
      ready: false,
      huovVanDatmenu: false,
      huovTmDatmenu: false,
      huov_van_tijd1Keuzes: [],
      huov_van_tijd2Keuzes: [],
      huov_tm_tijd1Keuzes: [],
      huov_tm_tijd2Keuzes: [],
      huov: {},
      confirmDialog: false,
      confirmMessage: '',
      isOverridable: false
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.confirmMessage = '';
      this.isOverridable = false;
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovArrDep.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovArrDep",
          },
          getHuovArrDep: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovArrDep;
            res.data.getHuovArrDep.huov_van_tijd1Keuzes.forEach(function (van_tijd1) {
              deze.huov_van_tijd1Keuzes.push(van_tijd1);
            });
            res.data.getHuovArrDep.huov_van_tijd2Keuzes.forEach(function (van_tijd2) {
              deze.huov_van_tijd2Keuzes.push(van_tijd2);
            });
            res.data.getHuovArrDep.huov_tm_tijd1Keuzes.forEach(function (tm_tijd1) {
              deze.huov_tm_tijd1Keuzes.push(tm_tijd1);
            });
            res.data.getHuovArrDep.huov_tm_tijd2Keuzes.forEach(function (tm_tijd2) {
              deze.huov_tm_tijd2Keuzes.push(tm_tijd2);
            });
            this.ready = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSave() {
      this.checkArrDep();
    },
    checkArrDep() {
      return this.$axios
        .post("ares/json/ares/huov/checkArrDep.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "checkArrDep",
          },
          checkArrDep: {
            huov_encrid: this.huov.huov_encrid,
            huov_van_dat: this.huov.huov_van_dat,
            huov_tm_dat: this.huov.huov_tm_dat,
            huov_van_tijd1: this.huov.huov_van_tijd1,
            huov_van_tijd2: this.huov.huov_van_tijd2,
            huov_tm_tijd1: this.huov.huov_tm_tijd1,
            huov_tm_tijd2: this.huov.huov_tm_tijd2
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log('res.data.checkArrDep', res.data.checkArrDep);

            // Check if there's a message from checkArrDep
            if (res.data.checkArrDep.text !== '') {
              this.confirmMessage = res.data.checkArrDep.text;
              this.isOverridable = res.data.checkArrDep.overridable || false;
              this.confirmDialog = true;
            } else {
              // No error, proceed directly with update
              this.proceedWithUpdate();
            }
          }
        });
    },
    cancelProcess() {
      this.confirmDialog = false;
    },
    proceedWithUpdate() {
      this.confirmDialog = false;
      this.updArrDep();
    },
    updArrDep() {
      this.$axios
        .post("ares/json/ares/huov/updArrDep2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updArrDep",
          },
          updArrDep: {
            huov_encrid: this.huov.huov_encrid,
            huov_van_dat: this.huov.huov_van_dat,
            huov_tm_dat: this.huov.huov_tm_dat,
            huov_van_tijd1: this.huov.huov_van_tijd1,
            huov_van_tijd2: this.huov.huov_van_tijd2,
            huov_tm_tijd1: this.huov.huov_tm_tijd1,
            huov_tm_tijd2: this.huov.huov_tm_tijd2
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updArrDep.text,
              color: res.data.updArrDep.color,
            });
            if (res.data.updArrDep.color == "success" || res.data.updArrDep.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updArrDep.huov_encrid); }, 1000);
            }
            this.dialog = false;
          }
        });
    },
  }

};
</script>
